// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ExplorePlans_explorePlansSection__PAr5u {
  margin-bottom: 116px;
}
.ExplorePlans_explorePlansSection__PAr5u .ExplorePlans_title__266b6 {
  color: #061c3d;
  text-align: center;
  font-family: Roboto;
  font-size: 48px;
  font-style: normal;
  font-weight: 800;
  line-height: 110%; /* 52.8px */
  margin-bottom: 12px;
}
@media (max-width: 767px) {
  .ExplorePlans_explorePlansSection__PAr5u .ExplorePlans_title__266b6 {
    font-size: 28px;
  }
}
.ExplorePlans_explorePlansSection__PAr5u .ExplorePlans_subTitle__LiE49 {
  color: #566b84;
  text-align: center;
  font-family: Roboto;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%; /* 28.8px */
  max-width: 1086px;
  margin: 0 auto;
  margin-bottom: 54px;
}
.ExplorePlans_explorePlansSection__PAr5u .ExplorePlans_planCards__VoOdv {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  max-width: 1031px;
  gap: 25px;
  margin: 0 auto;
}
@media (max-width: 1023px) {
  .ExplorePlans_explorePlansSection__PAr5u .ExplorePlans_planCards__VoOdv {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (max-width: 767px) {
  .ExplorePlans_explorePlansSection__PAr5u .ExplorePlans_planCards__VoOdv {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 580px) {
  .ExplorePlans_explorePlansSection__PAr5u .ExplorePlans_planCards__VoOdv {
    grid-template-columns: repeat(1, 1fr);
  }
}
.ExplorePlans_explorePlansSection__PAr5u .ExplorePlans_planCards__VoOdv .ExplorePlans_planCard__rof7Z {
  border-radius: 8px;
  border: 1px solid #e2e2e2;
  background: #fff;
  text-align: center;
  box-shadow: -9px 7px 52px 0px rgba(0, 0, 0, 0.09);
}
.ExplorePlans_explorePlansSection__PAr5u .ExplorePlans_planCards__VoOdv .ExplorePlans_planCard__rof7Z .ExplorePlans_allFeature__zxyEz {
  background: #e8e8e8;
  color: #000;
  text-align: center;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ExplorePlans_explorePlansSection__PAr5u .ExplorePlans_planCards__VoOdv .ExplorePlans_planCard__rof7Z .ExplorePlans_topContents__2o6QV {
  padding: 48px 36px 36px;
}
.ExplorePlans_explorePlansSection__PAr5u .ExplorePlans_planCards__VoOdv .ExplorePlans_planCard__rof7Z .ExplorePlans_topContents__2o6QV h5 {
  color: #000;
  text-align: center;
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.ExplorePlans_explorePlansSection__PAr5u .ExplorePlans_planCards__VoOdv .ExplorePlans_planCard__rof7Z .ExplorePlans_topContents__2o6QV h6 {
  color: #df7752;
  text-align: center;
  font-family: Inter;
  font-size: 25px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.ExplorePlans_explorePlansSection__PAr5u .ExplorePlans_planCards__VoOdv .ExplorePlans_planCard__rof7Z .ExplorePlans_topContents__2o6QV button {
  border-radius: 5px;
  background: #df7752;
  color: var(--Secondary-2, #fff);
  text-align: center;
  font-family: Inter;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  height: 32px;
  width: 100%;
  margin: 22px 0;
}
.ExplorePlans_explorePlansSection__PAr5u .ExplorePlans_planCards__VoOdv .ExplorePlans_planCard__rof7Z .ExplorePlans_topContents__2o6QV p {
  color: #566b84;
  text-align: center;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 15.6px */
}
.ExplorePlans_explorePlansSection__PAr5u .ExplorePlans_planCards__VoOdv .ExplorePlans_planCard__rof7Z .ExplorePlans_bottomContents__poQvo {
  padding: 22px 36px 33px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.ExplorePlans_explorePlansSection__PAr5u .ExplorePlans_planCards__VoOdv .ExplorePlans_planCard__rof7Z .ExplorePlans_bottomContents__poQvo p {
  color: #454545;
  font-family: Inter;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.ExplorePlans_explorePlansSection__PAr5u .ExplorePlans_planCards__VoOdv .ExplorePlans_planCard__rof7Z .ExplorePlans_tickContent__iO2t3 {
  display: flex;
  align-items: center;
  gap: 6px;
}`, "",{"version":3,"sources":["webpack://./src/containers/LandingPage/ExplorePlans.module.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;AACF;AAAE;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;EACA,mBAAA;AAEJ;AADI;EATF;IAUI,eAAA;EAIJ;AACF;AAFE;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AAIJ;AAFE;EACE,aAAA;EACA,qCAAA;EACA,iBAAA;EACA,SAAA;EACA,cAAA;AAIJ;AAHI;EANF;IAOI,qCAAA;EAMJ;AACF;AALI;EATF;IAUI,qCAAA;EAQJ;AACF;AAPI;EAZF;IAaI,qCAAA;EAUJ;AACF;AATI;EACE,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iDAAA;AAWN;AAVM;EACE,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAYR;AAVM;EACE,uBAAA;AAYR;AAXQ;EACE,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAaV;AAXQ;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAaV;AAXQ;EACE,kBAAA;EACA,mBAAA;EACA,+BAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;AAaV;AAXQ;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,WAAA;AAaV;AAVM;EACE,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAYR;AAXQ;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAaV;AAVM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAYR","sourcesContent":[".explorePlansSection {\r\n  margin-bottom: 116px;\r\n  & .title {\r\n    color: #061c3d;\r\n    text-align: center;\r\n    font-family: Roboto;\r\n    font-size: 48px;\r\n    font-style: normal;\r\n    font-weight: 800;\r\n    line-height: 110%; /* 52.8px */\r\n    margin-bottom: 12px;\r\n    @media (max-width: 767px) {\r\n      font-size: 28px;\r\n    }\r\n  }\r\n  & .subTitle {\r\n    color: #566b84;\r\n    text-align: center;\r\n    font-family: Roboto;\r\n    font-size: 18px;\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    line-height: 160%; /* 28.8px */\r\n    max-width: 1086px;\r\n    margin: 0 auto;\r\n    margin-bottom: 54px;\r\n  }\r\n  & .planCards {\r\n    display: grid;\r\n    grid-template-columns: repeat(3, 1fr);\r\n    max-width: 1031px;\r\n    gap: 25px;\r\n    margin: 0 auto;\r\n    @media (max-width: 1023px) {\r\n      grid-template-columns: repeat(3, 1fr);\r\n    }\r\n    @media (max-width: 767px) {\r\n      grid-template-columns: repeat(2, 1fr);\r\n    }\r\n    @media (max-width: 580px) {\r\n      grid-template-columns: repeat(1, 1fr);\r\n    }\r\n    & .planCard {\r\n      border-radius: 8px;\r\n      border: 1px solid #e2e2e2;\r\n      background: #fff;\r\n      text-align: center;\r\n      box-shadow: -9px 7px 52px 0px rgba(0, 0, 0, 0.09);\r\n      & .allFeature {\r\n        background: #e8e8e8;\r\n        color: #000;\r\n        text-align: center;\r\n        font-family: Inter;\r\n        font-size: 12px;\r\n        font-style: normal;\r\n        font-weight: 400;\r\n        line-height: 130%;\r\n        height: 22px;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n      }\r\n      & .topContents {\r\n        padding: 48px 36px 36px;\r\n        & h5 {\r\n          color: #000;\r\n          text-align: center;\r\n          font-family: Inter;\r\n          font-size: 20px;\r\n          font-style: normal;\r\n          font-weight: 700;\r\n          line-height: normal;\r\n        }\r\n        & h6 {\r\n          color: #df7752;\r\n          text-align: center;\r\n          font-family: Inter;\r\n          font-size: 25px;\r\n          font-style: normal;\r\n          font-weight: 600;\r\n          line-height: normal;\r\n        }\r\n        & button {\r\n          border-radius: 5px;\r\n          background: #df7752;\r\n          color: var(--Secondary-2, #fff);\r\n          text-align: center;\r\n          font-family: Inter;\r\n          font-size: 15px;\r\n          font-style: normal;\r\n          font-weight: 600;\r\n          line-height: normal;\r\n          height: 32px;\r\n          width: 100%;\r\n          margin: 22px 0;\r\n        }\r\n        & p {\r\n          color: #566b84;\r\n          text-align: center;\r\n          font-family: Inter;\r\n          font-size: 12px;\r\n          font-style: normal;\r\n          font-weight: 400;\r\n          line-height: 130%; /* 15.6px */\r\n        }\r\n      }\r\n      & .bottomContents {\r\n        padding: 22px 36px 33px;\r\n        display: flex;\r\n        flex-direction: column;\r\n        gap: 16px;\r\n        & p {\r\n          color: #454545;\r\n          font-family: Inter;\r\n          font-size: 11px;\r\n          font-style: normal;\r\n          font-weight: 400;\r\n          line-height: normal;\r\n        }\r\n      }\r\n      & .tickContent {\r\n        display: flex;\r\n        align-items: center;\r\n        gap: 6px;\r\n      }\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"explorePlansSection": `ExplorePlans_explorePlansSection__PAr5u`,
	"title": `ExplorePlans_title__266b6`,
	"subTitle": `ExplorePlans_subTitle__LiE49`,
	"planCards": `ExplorePlans_planCards__VoOdv`,
	"planCard": `ExplorePlans_planCard__rof7Z`,
	"allFeature": `ExplorePlans_allFeature__zxyEz`,
	"topContents": `ExplorePlans_topContents__2o6QV`,
	"bottomContents": `ExplorePlans_bottomContents__poQvo`,
	"tickContent": `ExplorePlans_tickContent__iO2t3`
};
export default ___CSS_LOADER_EXPORT___;
